import Difficulty from 'app/frontend/types/custom/Difficulty'
import { getRequest, postRequest, putRequest } from '.'

export type DefaultSetupSelectionUpdate = {
  character_id: number
  selected?: boolean
  role?: string
  spec_id?: number | null
  alt_character_id?: number
}

export const getDefaultSetups = async (
  teamId: number,
): Promise<wowaudit.DefaultSetup[]> => {
  return await getRequest(`/api/teams/${teamId}/default_setups`)
}

export const upsertDefaultSetup = async (
  teamId: number,
  defaultSetup: {
    encounter_id: number
    difficulty: Difficulty
    enabled: boolean
  },
): Promise<wowaudit.DefaultSetup> => {
  return await postRequest(`/api/teams/${teamId}/default_setups`, {
    default_setup: defaultSetup,
  })
}

export const updateDefaultSetupSelection = async (
  teamId: number,
  defaultSetupId: number,
  selection: DefaultSetupSelectionUpdate,
): Promise<wowaudit.DefaultSetup> => {
  return await putRequest(
    `/api/teams/${teamId}/default_setups/${defaultSetupId}`,
    {
      default_setup: { selection },
    },
  )
}
